import { z } from 'zod';
import { dateSchema, idSchema } from './common.schema.js';
/**
 * The company address book (24.09.2026): the people behind the vendors.
 * Everybody reads and everybody adds; the phone number is the identity —
 * e-mails may repeat, kontakt@firma.pl serves many people.
 */
/** Digits and a leading + only — one spelling per number. */
export function normalizePhone(value) {
    const stripped = value.replace(/[^\d+]/g, '');
    return stripped.startsWith('+') ? `+${stripped.slice(1).replace(/\+/g, '')}` : stripped;
}
export const contactSchema = z.object({
    id: idSchema,
    firstName: z.string(),
    lastName: z.string(),
    phone: z.string(),
    email: z.string().nullable(),
    companyName: z.string().nullable(),
    vendorId: idSchema.nullable(),
    vendorName: z.string().nullable(),
    createdAt: dateSchema,
});
export const createContactSchema = z.object({
    firstName: z.string().trim().min(2, 'Podaj imię').max(60),
    lastName: z.string().trim().min(2, 'Podaj nazwisko').max(60),
    phone: z
        .string()
        .trim()
        .min(1, 'Podaj numer telefonu')
        .refine((value) => normalizePhone(value).replace('+', '').length >= 7, {
        message: 'Numer telefonu jest za krótki',
    }),
    /** Empty string normalised to null: "no e-mail" has one representation. */
    email: z
        .string()
        .trim()
        .email('Nieprawidłowy adres e-mail')
        .max(120)
        .or(z.literal(''))
        .nullish()
        .transform((value) => value || null),
    companyName: z
        .string()
        .trim()
        .max(120)
        .nullish()
        .transform((value) => value || null),
    vendorId: z
        .string()
        .nullish()
        .transform((value) => value || null),
});
export const updateContactSchema = createContactSchema.partial();
//# sourceMappingURL=contact.schema.js.map